export const trackTypes = {
  free: "free",
  private: "private",
  paid: "paid",
};
